import { render } from "./badgeEmployStatus.vue?vue&type=template&id=a1794bd2"
import script from "./badgeEmployStatus.vue?vue&type=script&lang=js"
export * from "./badgeEmployStatus.vue?vue&type=script&lang=js"

import exportComponent from "/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__